import md5 from "md5";
import { request } from "umi";

export async function uploadFile(params: { path: string; file: File; origin?: boolean }) {
  const { path, file } = params;
  const fileWithoutSplit = new File([file], `${md5(file.name)}.${file.name.split(".").at(-1)}`, {
    type: file.type,
  });
  const formData = new FormData();
  formData.append("file", fileWithoutSplit);
  return request("/core/file/user", {
    method: "POST",
    params: { path, origin: !!origin },
    data: formData,
  });
}

export async function getDict(params: { category: string }) {
  return request("/core/dict/list", {
    params,
  });
}

/**
 * 创建通用二维码
 * @return listItem {
 * 	{string} param 二维码传递参数
 */
export async function createCommonQRCode(params: Record<string, any>) {
  return request("/core/relatives/getQrCode", {
    params,
  });
}

/**
 * 创建通用二维码
 * @return listItem {
 * 	{string} param 二维码传递参数
 */
export async function getSetting(params: { confKey: string }) {
  return request("/core/sys/conf/get", {
    params,
  });
}
